import React from 'react';
var SpinnerCustom = function SpinnerCustom(_ref) {
  var isLoading = _ref.isLoading;
  var ret = /*#__PURE__*/React.createElement(React.Fragment, null);
  var elementSpinner = /*#__PURE__*/React.createElement("div", {
    id: "spinnerModal"
  }, /*#__PURE__*/React.createElement("div", {
    id: "spinner",
    className: "spinnerCustom",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-circle-notch fa-4x fa-spin colorSpinner"
  })));
  isLoading ? ret = elementSpinner : null;
  return ret;
};
export default SpinnerCustom;